import React, {PropTypes, Component} from 'react'
import classnames from 'classnames'

const STATUS = [
  __('Created', 'teacher'),
  __('Invited', 'teacher'),
  __('Confirm', 'teacher'),
  __('Declined', 'teacher')
]

const STATUS_CLASS = ['created', 'invited', 'confirm', 'declined']

class TeacherStatusTd extends Component {
  constructor(props){
    super(props)
  }

  static propTypes = {
    teacher: PropTypes.object.isRequired
  }


  render(){
    let {teacher} = this.props

    let status = STATUS[teacher.stState]
    let classname = STATUS_CLASS[teacher.stState]

    return(
      <div className='teacher-name'>
        <div className={ 'text-center ' + 'teacher-invite-status ' +classname}>{status}</div>
      </div>
    )
  }
}


export default (TeacherStatusTd)



// WEBPACK FOOTER //
// ./src/containers/pages/Teacher/TeacherTable/TeacherStatusTd.js